/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Min_Duration_SecondsInputs */

const en_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Duration (seconds)`)
};

const fr_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée min (secondes)`)
};

const de_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestdauer (Sekunden)`)
};

const it_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata minima (secondi)`)
};

const ru_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная продолжительность (секунды)`)
};

const es_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración mínima (segundos)`)
};

const zh_cn2_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最短持续时间（秒）`)
};

const ja_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小継続時間（秒）`)
};

const hi_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम अवधि (सेकंड)`)
};

const pt_pt2_min_duration_seconds = /** @type {(inputs: Min_Duration_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração mínima (segundos)`)
};

/**
* | output |
* | --- |
* | "Min Duration (seconds)" |
*
* @param {Min_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const min_duration_seconds = /** @type {((inputs?: Min_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Min_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_min_duration_seconds(inputs)
	if (locale === "de") return de_min_duration_seconds(inputs)
	if (locale === "it") return it_min_duration_seconds(inputs)
	if (locale === "ru") return ru_min_duration_seconds(inputs)
	if (locale === "es") return es_min_duration_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_min_duration_seconds(inputs)
	if (locale === "ja") return ja_min_duration_seconds(inputs)
	if (locale === "hi") return hi_min_duration_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_min_duration_seconds(inputs)
	return en_min_duration_seconds(inputs)
});